import { Box, Flex, Text } from '@chakra-ui/react';
import { getSourceColor, getSourceLabel } from '../../../components/SourceBadge';

/** Shared top plot strip (legend sits in this band). Same on ranking, timeseries, and invoicing. */
export const MARKETPLACE_CHART_TOP_MARGIN = 32;

export type ChartLegendItem = { key?: string; label: string; color: string };

/**
 * Legend pinned to the visible chart (top-right).
 * Render outside any overflow/scroll container so it does not travel with the bars.
 */
export function MarketplaceChartLegend({
    sourceKeys,
    items,
    isFullscreen = false,
}: {
    sourceKeys?: string[];
    items?: ChartLegendItem[];
    isFullscreen?: boolean;
}) {
    const resolved: ChartLegendItem[] = items ?? (sourceKeys ?? []).map((src, i) => ({
        key: src,
        label: getSourceLabel(src),
        color: getSourceColor(src, i),
    }));
    if (resolved.length === 0) return null;
    return (
        <Flex
            position="absolute"
            top="8px"
            right={1}
            zIndex={1}
            pointerEvents="none"
            align="center"
            justify="flex-end"
            flexWrap="wrap"
            gap={3}
            maxW="70%"
            py={0.5}
        >
            {resolved.map((item, i) => (
                <Flex key={item.key ?? `${item.label}-${i}`} align="center">
                    <Box w="8px" h="8px" borderRadius="full" bg={item.color} mr={2} flexShrink={0} />
                    <Text fontSize={isFullscreen ? 'sm' : 'xs'} color="gray.600" fontWeight="medium" whiteSpace="nowrap">
                        {item.label}
                    </Text>
                </Flex>
            ))}
        </Flex>
    );
}
